import React from "react";

export const Dragonfly = ({ size = 40, style = {} }) => (
  <svg width={size} height={size * 0.6} viewBox="0 0 60 36" style={style}>
    <ellipse cx="30" cy="18" rx="14" ry="2" fill="#4A94BF" />
    <circle cx="16" cy="18" r="3" fill="#0F3049" />
    <g opacity="0.75">
      <ellipse cx="34" cy="10" rx="12" ry="4" fill="#D9E7F1" transform="rotate(-15 34 10)" />
      <ellipse cx="34" cy="26" rx="12" ry="4" fill="#D9E7F1" transform="rotate(15 34 26)" />
      <ellipse cx="44" cy="12" rx="8" ry="3" fill="#D9E7F1" transform="rotate(-10 44 12)" />
      <ellipse cx="44" cy="24" rx="8" ry="3" fill="#D9E7F1" transform="rotate(10 44 24)" />
    </g>
  </svg>
);
